import { render } from "./SupportTicket.vue?vue&type=template&id=76093cab&scoped=true"
import script from "./SupportTicket.vue?vue&type=script&lang=js"
export * from "./SupportTicket.vue?vue&type=script&lang=js"

import "./SupportTicket.vue?vue&type=style&index=0&id=76093cab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76093cab"]])

export default __exports__